module.exports = __webpack_public_path__ + "img/touchback_right.690cef83.jpg";